import { render } from "./StatsCustoms.vue?vue&type=template&id=5ab8b521&scoped=true"
import script from "./StatsCustoms.vue?vue&type=script&lang=ts"
export * from "./StatsCustoms.vue?vue&type=script&lang=ts"

import "./StatsCustoms.vue?vue&type=style&index=0&id=5ab8b521&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5ab8b521"

export default script